import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  Stack
} from '@mui/material'
import React from 'react'

import { VehicleEntry } from '../../sdk'
import { AddVehicleByVinAndLicensePlate } from './AddVehicleByVinAndLicensePlate'
interface Props {
  customerId: string
  submitCallback?: (vehicle: VehicleEntry) => void
  setShowForm: (value: boolean) => void
  licenseInput?: string
}

export const NewVehicleTabs: React.FC<Props> = ({
  customerId,
  submitCallback,
  setShowForm,
  licenseInput
}) => {
  return (
    <>
      <DialogContent>
        <Stack spacing={2}>
          <DialogContentText>
            Enter License Plate, VIN, or Custom Vehicle Information
          </DialogContentText>
          <AddVehicleByVinAndLicensePlate
            {...{
              customerId,
              submitCallback,
              licenseInput
            }}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setShowForm(false)}>Cancel</Button>
      </DialogActions>
    </>
  )
}
